export default {
	ABOUT: "about",
	MOBILE_PREORDER: "mobile_preorder",
	LOYALTY_PROGRAM: "loyalty_program",
	PUSH_NOTIFICATIONS: "push_notifications",
	TARIFFS: "tariffs",
	QUESTIONS: "questions",
}
